import useModalManagerStore, { ModalManagerStore } from "../components/ModalManager/useModalManagerStore";

export const useModal = (): [ModalManagerStore["setModal"], ModalManagerStore["resetModals"]] => {
    // const dispatch = useDispatch();
    // const set = (modal) => dispatch(setModal(modal));
    // const reset = () => dispatch(resetModal());
    // return [set, reset];
    const methods = useModalManagerStore();

    return [methods.setModal, methods.resetModals];
};
